import { UNLOCK_PIN } from "common-fe";

// #629 — resolve the effective PIN for a show: the per-show
// `scribeUnlockPin` set in scoreadmin-fe's Settings page (score-api's
// show-config.js), falling back to common-fe's legacy UNLOCK_PIN ("5432")
// when a show has none set. The one lock screen (ScribeLockPin, rendered by
// InitialSetup) calls this, and it is the only PIN prompt on the tablet (the
// approved design: one PIN per show, #3568 removed the second prompt). It
// replaces the old hardcoded 5432/1234 constants.
//
// #2316 — the per-show value is normalized, not returned verbatim. ScribeLockPin
// auto-submits only when `entered.length === pin.length` and then compares
// `entered === pin`, and it strips every non-digit from what is typed, so any stored value that is not a clean digit string (a number, an
// object, whitespace, a truthy-but-empty-looking string, letters) is a PIN no
// entry can ever match: staff see "wrong PIN" (or nothing at all) for every
// try. Such a value falls back to UNLOCK_PIN so a show can never lock its own
// scribes out. score-api's setShowScribeUnlockPin only accepts ^[0-9]{4,8}$,
// so a well-formed stored PIN is unchanged; surrounding whitespace is trimmed.
export function getScribePin(show) {
  const raw = show?.scribeUnlockPin;
  if (typeof raw !== "string") return UNLOCK_PIN;
  const pin = raw.trim();
  return /^\d+$/.test(pin) ? pin : UNLOCK_PIN;
}
